import { STORAGE_CDN_PATH } from "landings/storage/storage-constants";

export const PROJECT_LIST = [
  {
    title: 'Модульные системы шкафов Лион',
    description: 'Каталог готовых элементов — соберите удобное решение',
    benefits: [
      'Сделаем все работы за 7 дней',
      'Более 250 000 конфигураций',
      'Расширенная гарантия 10 лет',
      'Эксклюзивно в Лемана ПРО',
    ],
    img: {
      srcLd: `${STORAGE_CDN_PATH}/projects/lion-ld.png/lion-ld.png`,
      srcD: `${STORAGE_CDN_PATH}/projects/lion-d.png/lion-d.png`,
      srcT: `${STORAGE_CDN_PATH}/projects/lion-t.png/lion-t.png`,
      src: `${STORAGE_CDN_PATH}/projects/lion-m.png/lion-m.png`,
      alt: 'Изображение модульной системы шкафов Лион',
    },
    button: {
      label: 'Собрать комплект',
      href: '/proektirovanie-i-dizayn/sistema-hraneniya-lion/',
      title: 'Модульная система шкафов Лион',
    },
  },
  {
    title: 'Шкафы и двери-купе\nна заказ',
    description: 'Каждый миллиметр под размеры и особенности вашей комнаты.',
    benefits: [
      'Сделаем все работы за 21 день',
      'Тысячи материалов и цветов',
      'Размеры с точностью до 1 мм',
      'Бесплатный дизайн-проект',
    ],
    img: {
      srcLd: `${STORAGE_CDN_PATH}/projects/wardrobes-ld.png/wardrobes-ld.png`,
      srcD: `${STORAGE_CDN_PATH}/projects/wardrobes-d.png/wardrobes-d.png`,
      srcT: `${STORAGE_CDN_PATH}/projects/wardrobes-t.png/wardrobes-t.png`,
      src: `${STORAGE_CDN_PATH}/projects/wardrobes-m.png/wardrobes-m.png`,
      alt: 'Изображение шкафа',
    },
    button: {
      label: 'Навести порядок',
      href: '/uslugi/proektirovanie-i-dizayn/shkafy-na-zakaz/',
      title: 'Шкафы и двери-купе на заказ',
    },
  },
];
